import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

import { IPovertyLevel } from '@app/common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class PovertyLevelData<T = any> {

  constructor(private _api: FsApi) { }

  public create(data: IPovertyLevel = { id: null }): IPovertyLevel {
    return data;
  }

  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `povertylevels/${id}`,
      query,
      {
        key: 'povertyLevel',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'povertylevels',
      query,
      {
        key: 'povertyLevels',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `povertylevels/${data.id}`,
      data,
      {
        key: 'povertyLevel',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'povertylevels',
      data,
      {
        key: 'povertyLevel',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `povertylevels/${data.id}`,
      data,
      {
        key: 'povertyLevel',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
